import styled from 'styled-components';

import SegmentedControl from 'components/shared/SegmentedControl';
import { useBusinessDevelopmentActions, useBusinessDevelopmentStore } from 'stores/businessDevelopmentStore';
import { Label } from 'styles/typography';

import { VIEW_BY_OPTIONS, ViewBy } from './constants';

export default function ViewBySelector() {
  const viewBy = useBusinessDevelopmentStore((state) => state.viewBy);
  const { setViewBy } = useBusinessDevelopmentActions();

  return (
    <ViewByRow>
      <ViewByLabel>View By:</ViewByLabel>
      <SegmentedControl
        options={[...VIEW_BY_OPTIONS]}
        selectedValue={viewBy}
        onChange={(val) => setViewBy(val as ViewBy)}
        mobileFullWidth
      />
    </ViewByRow>
  );
}

const ViewByRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ViewByLabel = styled(Label)`
  color: ${({ theme }) => theme.colors.black75};

  @media (max-width: 800px) {
    display: none;
  }
`;
